import { useCreateStore } from '@/entities/create';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { showToast } from '@/shared/utils/toast';
import { useRouter } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

export const CreateNewSavePopup = () => {
    const router = useRouter();
    const { closeModal } = useModalStore();
    const { setState: createSetState, editExamName } = useCreateStore();
    const [title, setTitle] = useState<string>(editExamName ? `${editExamName}(복사본)` : '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(event.target.value);
    };

    useEffect(() => {
        if (title.length === 50) {
            showToast('자료명은 50자를 초과할 수 없습니다.', 2000, 'error');
        }
    }, [title]);

    return (
        <div className="ki-dim ttukttak">
            <div className="pos-center">
                <div className="pop_wrap pop_size_small edit_save_popup">
                    <div className="modal_header">
                        <div className="title">다른 이름으로 저장</div>
                    </div>
                    <div className="pop_contents edit_save_cont">
                        <div className="set-file-content content-type1">
                            <div className="form-row block">
                                <div className="form-label size-type1 title_wrap">
                                    <div className="option_title">저장할 자료명</div>
                                </div>
                                <div className="form-td">
                                    <div className="text-box">
                                        <input
                                            maxLength={50}
                                            type="text"
                                            placeholder={'자료명(복사본)'}
                                            title="자료명 입력"
                                            onChange={handleChange}
                                            value={title}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bt_wrap cont-mt2">
                            <button
                                className="btn btn-default line_gray1 pop_cancle2"
                                onClick={() => closeModal('create_newsave_popup')}
                            >
                                취소
                            </button>
                            <button
                                className="btn btn-default blue page_next"
                                onClick={() => {
                                    createSetState('editNewExamName', title);
                                    createSetState('requestSave', 'newsave');
                                    closeModal('create_newsave_popup');
                                }}
                            >
                                저장
                            </button>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn-x btn-x-white"
                        onClick={() => closeModal('create_newsave_popup')}
                    >
                        <span className="sr-only">팝업 닫기</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
